export type PrimaryColorConfig = {
  name?: string
  light?: string
  main: string
  dark?: string
  label?: string // human-readable display name
}

// Primary color presets — add new entries here to expand the theme picker.
// FIRST ENTRY IS THE DEFAULT. Indigo leads because Mocha was never a choice any
// user made: it was simply first in this list, which is why every screen shipped
// brown. Mocha is still selectable, just not the default. Indigo matches the
// mobile app (#4338CA) so both products read as the same company.
const primaryColorConfig: PrimaryColorConfig[] = [
  {
    name: 'primary-indigo',
    label: 'Indigo',
    light: 'rgb(99, 102, 241)',
    main: 'rgb(67, 56, 202)',
    dark: 'rgb(55, 48, 163)'
  },
  {
    name: 'primary-mocha',
    label: 'Mocha',
    light: 'rgb(196, 154, 108)',
    main: 'rgb(164, 113, 72)',
    dark: 'rgb(122, 82, 53)'
  },
  {
    name: 'primary-1',
    label: 'Violet',
    light: 'rgb(143, 133, 243)',
    main: 'rgb(115, 103, 240)',
    dark: 'rgb(103, 93, 216)'
  },
  {
    name: 'primary-2',
    label: 'Teal',
    light: 'rgb(78, 176, 177)',
    main: 'rgb(13, 147, 148)',
    dark: 'rgb(9, 107, 108)'
  },
  {
    name: 'primary-3',
    label: 'Amber',
    light: 'rgb(255, 194, 90)',
    main: 'rgb(255, 171, 29)',
    dark: 'rgb(186, 125, 21)'
  },
  {
    name: 'primary-4',
    label: 'Rose',
    light: 'rgb(240, 113, 141)',
    main: 'rgb(235, 61, 99)',
    dark: 'rgb(172, 45, 72)'
  },
  {
    name: 'primary-5',
    label: 'Sky',
    light: 'rgb(92, 175, 241)',
    main: 'rgb(32, 146, 236)',
    dark: 'rgb(23, 107, 172)'
  }
]

export default primaryColorConfig
